import { Controller } from "@hotwired/stimulus"

/**
 * PDF Preview controller using native <dialog> element
 *
 * Place the controller on a container element that wraps both:
 * - trigger buttons with data-action="click->pdf-preview#open"
 *   and data-pdf-preview-url-param / data-pdf-preview-title-param
 * - a <dialog> with data-pdf-preview-target="dialog"
 *   containing an <iframe> with data-pdf-preview-target="frame"
 */
export default class extends Controller {
  static targets = ["dialog", "frame", "title"]

  open({ params: { url, title } }) {
    this.frameTarget.src = url
    if (this.hasTitleTarget && title) {
      this.titleTarget.textContent = title
    }
    this.dialogTarget.showModal()
  }

  close() {
    this.dialogTarget.close()
    this.frameTarget.src = ""
  }
}
